var isMobile = false; //initiate as false
// device detection
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
  /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
  isMobile = true;
}

$(function () {
  if(location.search.indexOf('utm_source=') > -1){
    $('.links-externos').show()
  }
  else{
    $('.links-externos').hide()
  }

  // Carrega itens do select
  $.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados', function (data) {

    var listStates = [];
    var options = '<option selected="true" disabled="disabled">Selecione o seu estado</option>';
    $.each(data, function (key, val) {
      listStates.push(val.nome);
      listStates.sort()
    });

    $.each(listStates, function (key) {
      options += '<option value="' + listStates[key] + '">' + listStates[key] + '</option>';
    });
    $("#lista-estados").html(options);
  })

  // Dados catálogo atual
  var urlCatalogoAtual = "https://catalogo.jequiti.com.br/episodio-15-rxvahc/?page=1"  + location.search.replace('?', '&');
  var episodioAtual = "15"
  var imgCapaCatalogoAtual = "_assets/img/capas/capa-catalogo-epi-15.png"
  var imgCapaCatalogoAtualMobile = "_assets/img/capas/mobile/capa-catalogo-epi-15.png"
  var qrCodeAtual = "_assets/img/qrcodes/qr-code-epi-15.png"

  // Dados catálogo anterior
  var urlCatalogoAnterior = "https://catalogo.jequiti.com.br/episodio-14-uxvgxk/?page=1" + location.search.replace('?', '&');
  var episodioAnterior = "14"
  var imgCapaCatalogoAnterior = "_assets/img/capas/capa-catalogo-epi-14.png"
  var imgCapaCatalogoAnteriorMobile = "_assets/img/capas/mobile/capa-catalogo-epi-14.png"
  var qrCodeAnterior = "_assets/img/qrcodes/qr-code-epi-14.png"


  // ['Ceará', 'Piauí', 'Pernambuco', 'Paraíba', 'Rio Grande do Norte', 'Rondônia', 'Acre', 'Amazonas', 'Roraima', 'Pará', 'Amapá', 'Tocantins', 'Maranhão', 'Alagoas', 'Sergipe', 'Bahia','Mato Grosso do Sul', 'Distrito Federal', 'Goiás', 'Mato Grosso', 'Rio Grande do Sul', 'Paraná', 'Santa Catarina', 'Rio de Janeiro', 'Espírito Santo', 'Minas Gerais', 'São Paulo'];

  var estadosCatalogoAnterior = [''];



  // Compartilhamento nas redes sociais
  function socialWindow(url) {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
    window.open(url, "NewWindow", params);
  }

  // Funcao que mostra o catálogo selecionado, aplicando os dados
  function showCatalog(estado, urlCatalog, episodio, imgCapa, imgCapaMobile, qrCode) {
    if (isMobile) {
      var urlShareWhatsapp = "https://wa.me/?text=" + "Jequiti Ao Vivo " + urlCatalog;
    } else {

      var urlShareWhatsapp = "https://web.whatsapp.com/send?text=" + "Jequiti Ao Vivo " + urlCatalog;
    }

    $('.regiao-selecionada__estado').text(estado);
    $('.dados-catalogo__ver-catalogo').attr('href', urlCatalog + "&regiao=" + document.querySelector('#lista-estados').value);
    $('.link-compartilhamento__link').text(urlCatalog) + "&regiao=" + document.querySelector('#lista-estados').value;
    $('.dados-catalogo__numero-episodio').text(episodio)
    $('.catalogo-selecionado-capa img').attr('src', imgCapa)
    $('.catalogo-selecionado-capa source').attr('srcset', imgCapaMobile)
    $('.qr-code__img').css('background-image', "url(" + qrCode + ")")
    $('.redes-sociais__midia.whatsapp').attr('href', urlShareWhatsapp)

    //Cria url para compartilhamento baseado no catálogo
    $(".redes-sociais__midia.facebook").on('click', function (e) {
      e.preventDefault();
      ga('send', 'event', 'Share', 'Facebook');
      var url = "https://www.facebook.com/sharer.php?u=" + urlCatalog;
      socialWindow(url);
    });

    // $(".redes-sociais__midia.whatsapp").on('click', function (e) {
    //   e.preventDefault();
    //   ga('send', 'event', 'Share', 'Whatsapp');
    //   if (isMobile) {
    //     var url = "https://wa.me/?text=" + "Jequiti Ao Vivo " + urlCatalog;
    //   } else {

    //     var url = "https://web.whatsapp.com/send?text=" + "Jequiti Ao Vivo " + urlCatalog;
    //   }
    //   socialWindow(url);
    // })

    // $('.selecionar-estado').fadeOut();

    // $('.catalogo-selecionado').fadeIn();
  }

  //Define catálogo a ser mostrado
  $('.bt-buscar').on('click', function (e) {
    var selectValue = $('#lista-estados').val();
    ga("send", "event", "Select", selectValue);

    if(selectValue == null) {
      alert('Selecione uma opção');
      return
    }


    if ($.inArray(selectValue, estadosCatalogoAnterior) !== -1) {
      showCatalog(selectValue, urlCatalogoAnterior, episodioAnterior, imgCapaCatalogoAnterior, imgCapaCatalogoAnteriorMobile, qrCodeAnterior );
      $('.dados-catalogo__ver-catalogo')[0].click();
      return;
    }



    // console.log($('.dados-catalogo__ver-catalogo').attr('href'))
    showCatalog(selectValue, urlCatalogoAtual, episodioAtual, imgCapaCatalogoAtual, imgCapaCatalogoAtualMobile, qrCodeAtual );

    // console.log($('.dados-catalogo__ver-catalogo'))
    // console.log($('.dados-catalogo__ver-catalogo')[0])

    $('.dados-catalogo__ver-catalogo')[0].click();
    // $(location).attr('href', $('.dados-catalogo__ver-catalogo').attr('href'));
  })

  // Recomeça a escolha
  $('.regiao-selecionada__alterar-regiao').on('click', function () {
    $('.catalogo-selecionado').fadeOut();
    $('.selecionar-estado').fadeIn();
  })

  // Copia link de compartilhamento
  var clipboard = new ClipboardJS('.link-compartilhamento-bt');

  clipboard.on('success', function (e) {
    ga('send', 'event', 'Copied', 'link-compartilhamento');
    $('.link-compartilhamento__msg').fadeIn(300).delay(500).fadeOut(300);
    e.clearSelection();
  });

  // Envia GA do catálogo visualizado
  $('.dados-catalogo__ver-catalogo').on('click', function (e) {
    var selectValue = $('#lista-estados').val();
    ga('send', 'event', 'Open', 'ver-catalogo', selectValue);
  })
});
